import { LoanService, AuthService } from '@/utils/service'
export const getUserInfo = () => {
  return new LoanService({
    url: '/loan/app/user/v5/user/info',
    method: 'get'
  })
}
/**
 * 获得账户余额页面链接
 */
export const getCmbcBalanceUrl = () => {
  return new AuthService({
    url: '/api/apply/cmbc/url/balance',
    method: 'get',
    data: {
      source: 'h5_wallet',
      productId: 'DM-QBXJ'
    }
  })
}
export const getKeFu = () => {
  return new AuthService({
    url: '/api/kefu',
    method: 'get'
  })
}
/**
 * 获取民生账户信息
 */
export const getUserCmbcAccount = () => {
  return new AuthService({
    url: '/api/user/getCmbcAccount',
    method: 'get',
    data: {
      detail: 1
    }
  })
}
export const sendSmsCodeForModifyMobile = (params = {
  mobile: '',
  step: '1'
}) => {
  return new AuthService({
    url: '/api/user/security/mobile/sms',
    method: 'get',
    data: params
  })
}
export const modifyMobileForVerify = (params = {
  mobile: '',
  smsCode: ''
}) => {
  return new AuthService({
    url: '/api/user/security/mobile/verify',
    method: 'post',
    data: {
      mobile: params.mobile,
      smsCode: params.smsCode
    }
  })
}
export const modifyMobile = (params = {
  mobile: '',
  smsCode: ''
}) => {
  return new AuthService({
    url: '/api/user/security/mobile/modify',
    method: 'post',
    data: {
      mobile: params.mobile,
      smsCode: params.smsCode
    }
  })
}
export const modifyPwd = (params = {
  pwd: '',
  newPwd: '',
  captcha: ''
}) => {
  return new AuthService({
    url: '/api/user/security/pwd',
    method: 'post',
    data: params
  })
}
